import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../lib/api";
import { fmtN } from "../../lib/format";

export default function InsightsPanel({ filters, onDrill }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/sales/insights`, { params: filters })
      .then((r) => setData(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [filters]);

  if (loading) return <div className="card empty">Menganalisis data...</div>;
  if (!data || !data.segments) return <div className="card empty">Tidak ada insight.</div>;

  const seg = data.segments[activeTab];
  return (
    <div data-testid="insights-panel">
      <div className="tabs">
        {data.segments.map((s, i) => (
          <button
            key={i}
            className={`tab ${activeTab === i ? "active" : ""} tab-${i === 0 ? "eft" : "tcp"}`}
            onClick={() => setActiveTab(i)}
            data-testid={`tab-${i === 0 ? "eft" : "tcp"}`}
          >
            <span className="tab-dot" />
            {s.label}
            <span className="tab-count">{fmtN(s.total)}</span>
          </button>
        ))}
      </div>
      {seg.empty ? (
        <div className="card empty">Tidak ada data untuk {seg.label} pada filter ini.</div>
      ) : (
        <div className="insights-grid" data-testid="insights-grid">
          {seg.insights.map((ins, i) => (
            <div
              key={i}
              className={`insight-card ${ins.tone} clickable`}
              onClick={() => onDrill && ins.drill && onDrill({
                title: `${seg.label} → ${ins.title}: ${ins.headline}`,
                key: ins.drill.key, value: ins.drill.value,
                extra_tujuan: seg.label,
              })}
              data-testid={`insight-${ins.type}`}
            >
              <div className="insight-title">{ins.title}</div>
              <div className="insight-headline">{ins.headline}</div>
              <div className="insight-value">{ins.value}</div>
              <div className="insight-body">{ins.body}</div>
              <div className="kpi-hint">Klik untuk drill-down →</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}